import { store } from '../../store'

export const deleteNotification = async ( id: number ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/questionnaires/notifications/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'QUESTIONNAIRE_DELETE_NOTIFICATION_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'QUESTIONNAIRE_DELETE_NOTIFICATION_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'QUESTIONNAIRE_DELETE_NOTIFICATION_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'QUESTIONNAIRE_DELETE_NOTIFICATION_OK' } )

}
